import Vue from 'vue';
import Router from 'vue-router';
import router, { RouteName } from './router';
import App from './App.vue';
import store from '@/store';
import 'lib-flexible/flexible';
import { initError } from '@/business/error.ts';
import { install, i18n } from '@/i18n';
import { util, CustomException, initReport, user, elk, mtaInit, request, url } from '@tencent/ppd-base-libs';
import share from '@/util/share';
import { install as fitComponentsPlugin } from '@/fit-components/common/lang';
import { set3rdShare } from '@/business/share.ts';
import axios from 'axios';
import { isLogin, refreshCode } from '@/business/login';
import { isThirtPart } from '@/business/third-part';
import SDK from '@/business/sdk';
// 舍弃util/login中的prom.wechatpay.com.hk域名登录，参考电信充值apps.wechatpay.com.hk的登录方式，通过跳转url取到code的方式登录，bisiness/login
axios.interceptors.request.use(
  (config) => {
    config.params = config.params || {};
    config.params.code = url.getUrlParam('code') || undefined;
    return config;
  },
  (error) => Promise.reject(error),
);
axios.interceptors.response.use(
  (response) => {
    const url = response.config.url || '';
    if (url.match(/\.json/)) {
      //  json格式后缀 直接通过
      return response;
    }
    const { data } = response;
    if (!isLogin(data) && !isThirtPart()) {
      refreshCode();
      // 避免执行后续逻辑
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 5000);
      });
    }
    if ('0' !== data.retcode) {
      return Promise.reject(data);
    }
    return response;
  },
  (error) => Promise.reject(error),
);
request.init(axios);

// 把SDK触发登录的动作挪到后面：
// SDK.init(); // 登录后才会有上报bi所需参数
// 国际化
Vue.use(install);
// fitcomponents国际化
Vue.use(fitComponentsPlugin);
// 处理路由信息
Vue.use(Router);
// rem布局
// 路由切换判断登录态
util.changeTitle(i18n('全球防疫動態追蹤'));
Vue.config.productionTip = false;
console.log('appEnv', process.env.VUE_APP_ENV);
const shareContent = {
  imgUrl: 'http://st.moneydata.hk/res/mojo_static/0eea575959c899dac185e89578ed6402.png',
  title: i18n('【持續更新】WeChat Pay HK 疫情動態追蹤'),
  desc: i18n('足不出户，了解新型冠状病毒疫情，保護自己與家人。'),
};
set3rdShare(shareContent);
initError({
  dsn: 'https://af6c22cce81a41faa3d2e10b2b6b7640@report.url.cn/sentry/2192',
  // webpack变异全局变量
  release: process.env.VUE_APP_SENTRY_VERSION,
  appEnv: process.env.NODE_ENV,
});
request.init(axios);
// 由于登陆态隔离
user.setUinKey('ia_refill_qluin'); // 这是疫情页面的openid，而不是钱包openid（@wx.hkg结尾），在bop系统上用wx号转换不到，要找后台

initReport(
  {
    router,
    appEnv: process.env.VUE_APP_ENV,
    business: process.env.VUE_APP_PKGNAME, // 区分业务，用于elk
    isReportPageStayedTime: true, // 是否上报页面停留时间
    sentry: {
      dsn: 'https://fcbca1ea618b4a71b9d74a399dde77f2@report.url.cn/sentry/1967',
      // webpack变异全局变量
      release: process.env.VUE_APP_SENTRY_VERSION,
    },
    bi: {
      reportNeedLogin: false,
    },
  },
  Vue,
);

if (isThirtPart()) {
  initVue();
} else {
  // SDK.init中执行登录：登录后才会有上报bi所需参数；登录后才初始化页面
  SDK.init()
    .then(() => {
      initVue();
    })
    .catch(() => {
      // 失败也initVue
      initVue();
    });
}

// showLoading()

/**
 * @method initVue
 * @description 实例
 */
async function initVue() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}

// 修复ios无点击态的BUG
document.body.addEventListener('touchstart', () => {});

share(shareContent, () => {});
